import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) { }

  public registerIcons(): void {
    this.iconRegistry.addSvgIcon(
      'tag',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/tag.svg')
    );
    this.iconRegistry.addSvgIcon(
      'box',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/box.svg')
    );
    this.iconRegistry.addSvgIcon(
      'arrow-right',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/arrow-right.svg')
    );
    this.iconRegistry.addSvgIcon(
      'plane',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/plane.svg')
    );
    this.iconRegistry.addSvgIcon(
      'ship',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/ship.svg')
    );
    this.iconRegistry.addSvgIcon(
      'arrival-plane',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/arrival-plane.svg')
    );
    this.iconRegistry.addSvgIcon(
      'departure-plane',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/departure-plane.svg')
    );

    this.iconRegistry.addSvgIcon(
      'user',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/user.svg')
    );
    this.iconRegistry.addSvgIcon(
      'pack',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/pack.svg')
    );
     this.iconRegistry.addSvgIcon(
      'mainStatus',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/main-status.svg')
    );
    this.iconRegistry.addSvgIcon(
      'calander',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/calander.svg')
    );
    this.iconRegistry.addSvgIcon(
      'document',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/document.svg')
    );

    
  }
}